import { useEffect } from "react";

export const useAgGridStyles = () => {
  useEffect(() => {
    const styleId = "ag-grid-row-border-fix";
    if (!document.getElementById(styleId)) {
      const style = document.createElement("style");
      style.id = styleId;
      style.textContent = `
        .ag-row {
          box-shadow: inset 0 -1px 0 0 rgba(0, 0, 0, 0.3) !important;
        }
        .ag-cell.ag-group-cell {
          background-color: transparent !important;
        }
        .mandatory-column-header .ag-header-cell-text::after {
          content: " *";
          color: #ff7875;
          font-weight: 700;
        }
        .ag-cell.mandatory-cell-error {
          border: 1px solid #ff4d4f !important;
          background-color: rgba(255, 77, 79, 0.12) !important;
        }
        .groupable-column-header .ag-header-cell-text {
          border-bottom: 1px solid #ffffff !important;
          padding-bottom: 2px;
        }
      `;
      document.head.appendChild(style);
    }
    return () => {
      const el = document.getElementById(styleId);
      if (el) el.remove();
    };
  }, []);
};
